import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";

import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Home from "./pages/Home";

import { ThemeProvider } from "styled-components";
import theme from "./styles/theme";
import { setConfiguration } from "react-grid-system";
import SignInPage from "./pages/SignInPage";
import BasicLayout from "./layouts/BasicLayout";
import { UserContext } from "./context/UserContext";
import { SemesterContext } from "./context/SemesterContext";
import useScript, { convertToSelect } from "./hooks/useScript";
import QuestsPage from "./pages/Quest/Quests";
import ActivityCalendarPage from "./pages/Calendar/ActivityCalendar";
import GraduateReportStatusPage from "./pages/Portfolio/GraduateReportStatus";
import MyQuestPage from "./pages/Quest/MyQuest";
import RoadMapPage from "./pages/RoadMap/RoadMap";
import axios from "axios";
import RoadMapDetailPage from "./pages/RoadMap/RoadMapDetail";
import RoadMapTimelinePage from "./pages/RoadMap/RoadMapTimeline";
import RecommendedRoadMapPage from "./pages/RoadMap/RecommendedRoadMap";
import SignOutPage from "./pages/SignOutPage";
import NotFoundPage from "./pages/NotFoundPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import InstructorQuestsPage from "./pages/Quest/InstructorQuests";
import StudentTimelinesPage from "./pages/RoadMap/StudentTimelines";
import { LocationInterface } from "./components/UtilsComponents";
import HelpPage from "./pages/HelpPage";
import InstructorStudentCreditsPage from "./pages/Credits/InstructorStudentCredits";
import StudentCreditsPage from "./pages/Credits/StudentCredits";
import InstructorStudentCardsPage from "./pages/Credits/InstructorStudentCards";
import { Role } from "./types/User";
import { AnnouncementPage } from "./pages/Announcements/Announcements";
import CompetencyDetail from "./pages/Quest/CompetencyDetail";
import SnackBar from "./components/SnackBar";
import { MasteryLevelPage } from "./pages/PillarMasteryLevel.tsx/MasteryLevelPage";
import { InstructorView } from "./pages/PillarMasteryLevel.tsx/InstructorView";
import { Portfolio } from "./pages/Portfolio/Portfolio";
import InstructorStudentCard from "./pages/Credits/InstructorStudentCard";
import MyCards from "./pages/Quest/MyCards";
import { UniversityContext } from "./context/UniversityContext";
import { getProgramShortNameForSemesterApi } from "./utils/programName";

setConfiguration({
  gutterWidth: theme.spacing.base * 3,
  containerWidths: [540, 740, 960, 1140, 1200],
  breakpoints: [576, 768, 992, 1200, 1600],
});

// const PrivateRoute = (props: RouteProps) => {
//   const userContext = useContext(UserContext);

//   // return <Route {...props} />;
//   return userContext.isSignedIn ? (
//     <Route {...props} />
//   ) : (
//     <Redirect to="/signin" />
//   );
// };
const ProtectedRoute = ({
  isSignedIn,
  redirectPath = "/signin",
  children,
}: any) => {
  if (!isSignedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
const UnprotectedRoute = ({
  isSignedIn,
  redirectPath = "/",
  children,
}: any) => {
  if (isSignedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
// declare global {
//   interface Window {
//     feather: { replace: () => void };
//   }
// }
// function loadWindow() {
//   window.feather?.replace();
// }
function App() {
  // useScript('https://unpkg.com/feather-icons/dist/feather.min.js', loadWindow);
  const [isLoading, setIsLoading] = useState(true);
  const userContext = useContext(UserContext);
  const semesterContext = useContext(SemesterContext);
  const universityContext = useContext(UniversityContext);
  const navigate = useNavigate();
  let location = useLocation() as LocationInterface;
  const [isRemindOpen, setIsRemindOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isWarningOpen, setIsWarningOpen] = useState<boolean>(false);
  const [warningMessage, setWarningMessage] = useState<string>("");
  const [isAOPendingOpen, setIsAOPendingOpen] = useState<boolean>(false);
  const [isAOReminderOpen, setIsAOReminderOpen] = useState<boolean>(false);
  const [aoReminderMessage, setAoReminderMessage] = useState<React.ReactNode>("");
  const loadedInstructorProgramRef = useRef<string>("");


  useEffect(() => {
    axios
      .get(`/version?university_code=CMKL`)
      .then((res) => {
        const tempData = res.data.versions?.map((v: any) => ({
          label: v.program_name + " : " + v.display_version + ". " + v.title,
          value: v.version_number,
          status: v.status,
        }));
        // .filter(
        //   (f: any) =>
        //     f.status === "Active Prime" || f.status === "Active Legacy"
        // );

        localStorage.setItem(
          "activeVersion",
          JSON.stringify(tempData.find((v: any) => v.status === "Active Prime"))
        );
        localStorage.setItem("allVersions", JSON.stringify(tempData));
        // const active = tempData.find((v: any) => v.status === "Active Prime");
        // console.log("active", tempData, active);
      })
      .catch(() => { });
    setIsLoading(true);
    axios
      .get("/user")
      .then((res) => {
        const storedRole = localStorage.getItem("role");
        const initialRole = JSON.parse(storedRole as string);
        if (initialRole && initialRole?.role_id) {
          if (initialRole.role === 1) {
            getStudentIdentity(
              initialRole.role_id,
              initialRole.role,
              initialRole.roles
            );
          } else if ([2, 6].includes(initialRole?.role)) {
            if (initialRole?.role === 2) {
              getInstructorIdentity(
                initialRole.role_id,
                initialRole.role,
                initialRole.roles
              );
            } else if (initialRole?.role === 6) {
              getAdminIdentity(
                initialRole.role_id,
                initialRole.role,
                initialRole.roles
              );
            }
          }
          // else if ([6].includes(initialRole?.role)) {
          //   getAdminIdentity(
          //     initialRole.role_id,
          //     initialRole.role,
          //     initialRole.roles
          //   );
          // }
          else {
            setIsLoading(false);
            navigate("/unauthorized");
          }
        } else {
          if (
            res.data.user.id &&
            res.data.user.roles &&
            Array.isArray(res.data.user.roles)
          ) {
            const roles = res.data.user.roles;
            let authorized = false;

            for (const role of roles) {
              if (role.role === 1) {
                getStudentIdentity(role.role_id, role.role, roles);
                authorized = true;
                break; // Stop after finding one authorized role
              } else if ([2].includes(role?.role)) {
                getInstructorIdentity(role.role_id, role.role, roles);
                authorized = true;
                break;
              } else if ([6].includes(role?.role)) {
                getAdminIdentity(role.role_id, role.role, roles);
                authorized = true;
                break;
              }
            }

            if (!authorized) {
              setIsLoading(false);
              navigate("/unauthorized");
            }

            // if (res.data.user.roles[0].role === 1) {
            //   getStudentIdentity(
            //     res.data.user.roles[0].role_id,
            //     res.data.user.roles[0].role,
            //     res.data.user.roles
            //   );
            // } else if ([2].includes(res.data.user.roles[0]?.role)) {
            //   getInstructorIdentity(
            //     res.data.user.roles[0].role_id,
            //     res.data.user.roles[0].role,
            //     res.data.user.roles
            //   );
            // } else if ([6].includes(res.data.user.roles[0]?.role)) {
            //   getAdminIdentity(
            //     res.data.user.roles[0].role_id,
            //     res.data.user.roles[0].role,
            //     res.data.user.roles
            //   );
            // } else {
            //   setIsLoading(false);
            //   navigate("/unauthorized");
            // }
          } else if (res.data.user.roles === null) {
            setIsLoading(false);
            navigate("/unauthorized");
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.response?.message === "Unauthorized") {
          navigate("/unauthorized");
          console.log("redirect to unauthorized !!!!!");
        }
      });
  }, []);

  useEffect(() => {
    userContext?.user.email && fetchAnouncement();
    userContext?.user.role === 1 && fetchCreditWarning();
    userContext?.user.role === 1 && fetchAOReminder();
    [2, 6].includes(userContext?.user.role) && fetchInstructorAOPending();
  }, [userContext?.user.email]);

  const getStudentIdentity = (
    stuId: string,
    role: number,
    roles: Array<Role>
  ) => {
    setIsLoading(true);
    axios
      .get(`/student/identity?student_id=${stuId}`)
      .then((res) => {
        if (res.data.student) {
          localStorage.setItem("identity", JSON.stringify(res.data.student));
          axios //for version select(AIE changes)
            .get(
              `/university?university_code=${res.data.student.university_code}`
            )
            .then((res1: any) => {
              if (res1.data.universities?.[0]?.program) {
                const programOptions = convertToSelect(
                  res1.data.universities?.[0]?.program,
                  "short_name",
                  "short_name"
                );

                universityContext.setAllPrograms(programOptions);

                universityContext.setProgram(
                  programOptions.find(
                    (v: any) => v.id === res.data.student.programs[0].id
                  )
                );
              }
              // axios
              //   .put(`version/select`, {
              //     version_number: res1.data.universities[0].active_version,
              //   })
              //   .then((res2: any) => {
              //     // console.log("succeed version select");
              //   })
              //   .catch(() => {
              //     console.log("error in fetching version");
              //   });
            })
            .catch(() => {
              console.log("error in fetching university");
            });
        }
        const roadmapView = localStorage.getItem("roadmapView");
        const initialValue = JSON.parse(roadmapView as string);
        if (initialValue) {
          if (
            initialValue?.value !== "" &&
            initialValue.url !== "/student-roadmaps"
          ) {
            userContext.setCurrentRoadmapView(initialValue);
          }
        }
        const timeView = localStorage.getItem("timeView");
        const initialTimeValue = JSON.parse(timeView as string);
        if (initialTimeValue) {
          if (initialTimeValue?.label !== "") {
            userContext.setCurrentTimeView(initialTimeValue);
          }
        }
        localStorage.setItem(
          "role",
          JSON.stringify({ role: role, role_id: stuId, roles: roles })
        );
        userContext.setCurrentUser({
          role: role,
          roles: roles,
          ...res.data.student,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const getInstructorIdentity = (
    insId: string,
    role: number,
    roles: Array<Role>
  ) => {
    axios
      .get(`/instructor/identity?instructor_id=${insId}`)
      .then((res) => {
        axios //for version select(AIE changes)
          .get(
            `/university?university_code=${res.data.instructor.university_code}`
          )
          .then((res1: any) => {
            if (res1.data.universities?.[0]?.program) {
              const programOptions = convertToSelect(
                res1.data.universities?.[0]?.program,
                "short_name",
                "short_name"
              );

              universityContext.setAllPrograms(programOptions);

              if (
                window.location.pathname !== "/announcement" &&
                window.location.pathname !== "/calendar"
              ) {
                universityContext.setProgram(programOptions?.find((prog: any) => prog?.short_name === "B.ENG. AiCE") || programOptions[0]);
              } else {
                universityContext.setProgram({
                  label: "ALL Programs",
                  value: "ALL",
                  degree_abbrev: "",
                  program_abbrev: "ALL",
                  id: "",
                  description: "",
                  first_semester: "",
                  program_name: "All Programs",
                  short_name: "",
                  university_code: "",
                  versions: [],
                });
              }
            }
            // axios
            //   .put(`version/select`, {
            //     version_number: res1.data.universities[0].active_version,
            //   })
            //   .then((res2: any) => {
            //     // console.log("succeed version select");
            //   })
            //   .catch(() => {
            //     console.log("error in fetching version");
            //   });
          })
          .catch(() => {
            console.log("error in fetching university");
          });
        const roadmapView = localStorage.getItem("roadmapView");
        const initialValue = JSON.parse(roadmapView as string);
        if (initialValue) {
          if (initialValue?.value !== "")
            userContext.setCurrentRoadmapView(initialValue);
        }
        const timeView = localStorage.getItem("timeView");
        const initialTimeValue = JSON.parse(timeView as string);
        if (initialTimeValue) {
          if (initialTimeValue?.label !== "")
            userContext.setCurrentTimeView(initialTimeValue);
        }
        userContext.setCurrentUser({
          role: role,
          roles: roles,
          ...res.data.instructor,
        });
        localStorage.setItem(
          "role",
          JSON.stringify({ role: role, role_id: insId, roles: roles })
        );
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const getAdminIdentity = (
    adminId: string,
    role: number,
    roles: Array<Role>
  ) => {
    axios
      .get(`/admin/identity?admin_id=${adminId}`)
      .then((res) => {
        axios //for version select(AIE changes)
          .get(`/university?university_code=${res.data.admin.university_code}`)
          .then((res1: any) => {
            if (res1.data.universities?.[0]?.program) {
              const programOptions = convertToSelect(
                res1.data.universities?.[0]?.program,
                "short_name",
                "short_name"
              );

              universityContext.setAllPrograms(programOptions);

              if (
                window.location.pathname !== "/announcement" &&
                window.location.pathname !== "/calendar"
              ) {
                universityContext.setProgram(programOptions?.find((prog: any) => prog?.short_name === "B.ENG. AiCE") || programOptions[0]);
              } else {
                universityContext.setProgram({
                  label: "ALL Programs",
                  value: "ALL",
                  degree_abbrev: "",
                  program_abbrev: "ALL",
                  id: "",
                  description: "",
                  first_semester: "",
                  program_name: "All Programs",
                  short_name: "",
                  university_code: "",
                  versions: [],
                });
              }
            }

            // axios
            //   .put(`version/select`, {
            //     version_number: res1.data.universities[0].active_version,
            //   })
            //   .then((res2: any) => {
            //     // console.log("succeed version select");
            //   })
            //   .catch(() => {
            //     console.log("error in fetching version");
            //   });
          })
          .catch(() => {
            console.log("error in fetching university");
          });
        const roadmapView = localStorage.getItem("roadmapView");
        const initialValue = JSON.parse(roadmapView as string);
        if (initialValue) {
          if (initialValue?.value !== "")
            userContext.setCurrentRoadmapView(initialValue);
        }
        const timeView = localStorage.getItem("timeView");
        const initialTimeValue = JSON.parse(timeView as string);
        if (initialTimeValue) {
          if (initialTimeValue?.label !== "")
            userContext.setCurrentTimeView(initialTimeValue);
        }
        userContext.setCurrentUser({
          role: role,
          roles: roles,
          ...res.data.admin,
        });
        localStorage.setItem(
          "role",
          JSON.stringify({ role: role, role_id: adminId, roles: roles })
        );
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // const identity = localStorage.getItem('identity');
  // const firstTerm =  JSON.parse(identity as string).first_term || '';
  useEffect(() => {
    if (userContext.user.role !== 1) return;

    semesterContext.setAllSemester([]);

    axios
      .get(
        `/semester?university_code=CMKL&program_name=${userContext?.userProgram?.program_name || universityContext?.selectedProgram?.short_name || universityContext?.selectedProgram?.label}`
      )
      .then((res) => {
        if (res.data.semesters) {
          const allSemesters = res.data.semesters;
          const allSemestersConvert = convertToSelect(
            allSemesters,
            "semester_name",
            "id"
          );
          semesterContext.setAllSemester(allSemestersConvert);
          localStorage.setItem(
            "allSemesters",
            JSON.stringify(allSemestersConvert)
          );
          const selectedSemester = localStorage.getItem("selectedSemester");
          const initialValue = JSON.parse(selectedSemester as string);
          if (!initialValue || initialValue?.value === "") {
            axios
              .get(
                `/semester/current?university_code=CMKL&program_name=${encodeURIComponent(
                  userContext?.user?.programs?.[0]?.program_name ||
                    universityContext?.selectedProgram?.short_name ||
                    ""
                )}`
              )
              .then((res) => {
                if (
                  res.data.semesters &&
                  res.data.semesters.semester_name !== ""
                ) {
                  semesterContext.setSemester({
                    label: res.data.semesters.semester_name,
                    value: res.data.semesters.id,
                    year: res.data.semesters.semester_name.split(" ")[1],
                    program:
                      universityContext?.selectedProgram?.short_name ||
                      universityContext?.selectedProgram?.label,
                    ...res.data.semesters,
                  });
                } else {
                  semesterContext.setSemester({
                    label: allSemesters[allSemesters.length - 1].semester_name,
                    value: allSemesters[allSemesters.length - 1].id,
                    year: allSemesters[
                      allSemesters.length - 1
                    ].semester_name.split(" ")[1],
                    ...allSemesters[allSemesters.length - 1],
                  });
                }
              })
              .catch(() => {
                semesterContext.setSemester({
                  label: allSemesters[allSemesters.length - 1].semester_name,
                  value: allSemesters[allSemesters.length - 1].id,
                  year: allSemesters[
                    allSemesters.length - 1
                  ].semester_name.split(" ")[1],
                  ...allSemesters[allSemesters.length - 1],
                });
              });
          } else {
            semesterContext.setSemester(initialValue);
          }
        }
      })
      .catch((err) => console.error(err));
  }, [
    userContext.user.role,
    userContext.user?.programs?.[0]?.id,
    userContext.userProgram?.program_name,
  ]);

  // Instructor/admin: reload semesters when selected program changes.
  // Explore and instructor-competencies use /semester/merged (ExploreMergedSelects) instead.
  useEffect(() => {
    if (![2, 6].includes(userContext.user.role)) return;
    if (
      location.pathname.includes("/explore") ||
      location.pathname.includes("/instructor-competencies")
    ) {
      return;
    }
    if (
      universityContext.selectedProgram?.label === "ALL" ||
      universityContext.selectedProgram?.value === "ALL"
    ) {
      return;
    }

    const programShortName = getProgramShortNameForSemesterApi(
            universityContext.selectedProgram
    );
    if (!programShortName) return;

    const previousProgram = loadedInstructorProgramRef.current;
    if (previousProgram === programShortName) return;

    loadedInstructorProgramRef.current = programShortName;
    const resetSelection = previousProgram !== "";
    semesterContext.loadSemestersForProgram(programShortName, resetSelection);
  }, [
    userContext.user.role,
    universityContext.selectedProgram?.id,
    universityContext.selectedProgram?.short_name,
    location.pathname,
  ]);

  // Instructor AO pending notification — retry once semester & program are ready
  useEffect(() => {
    if (![2, 6].includes(userContext.user.role)) return;
    if (!semesterContext.selectedSemester?.value) return;
    if (!universityContext.selectedProgram?.id) return;
    fetchInstructorAOPending();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    semesterContext.selectedSemester?.value,
    universityContext.selectedProgram?.id,
  ]);

  const fetchAnouncement = async () => {
    axios
      .get(`/announcement/remind?email=${userContext?.user.email}`)
      .then((res) => {
        if (res.data.isRemind === true) {
          const announcementShown = localStorage.getItem("announcementShown");
          if (announcementShown !== "true") {
            setIsRemindOpen(true);
            localStorage.setItem("announcementShown", "true");
          }
        } else {
        }
      })
      .catch((error) => {
        console.error("Error fetching announcement:", error);
      });
  };

  const fetchCreditWarning = async () => {
    const programName = userContext?.user?.programs?.[0]?.program_name;
    axios
      .get(`/student/credit-warning`, {
        params: {
          student_id: userContext?.user.id,
          ...(programName ? { program_name: programName } : {}),
        },
      })
      .then((res) => {
        if (res?.data?.warning === true) {
          setIsWarningOpen(true);
          setWarningMessage(res?.data?.message);
        } else {
        }
      })
      .catch((error) => {
        console.error("Error fetching credit warning:", error);
      });
  };

  const fetchAOReminder = async () => {
    const programName = userContext?.user?.programs?.[0]?.program_name || "";
    const studentId = userContext?.user?.id;
    if (!studentId || !programName) return;
    try {
      const res = await axios.get(
        `/student/reminders/instructor-approval?student_id=${studentId}&program_name=${encodeURIComponent(programName)}`
      );
      const data: Array<any> = res?.data?.data || [];
      if (!data.length) return;
      const newDecisions = data;
      const msgs = newDecisions.map((r, idx) => (
        <div key={idx} style={{ marginBottom: "8px", lineHeight: "1.4" }}>
          <div>&bull; {r.competency_code} &mdash; {r.status}</div>
          {r.comment && <div>Comment: {r.comment}</div>}
        </div>
      ));
      setAoReminderMessage(
        <div>
          <div style={{ marginBottom: "8px" }}>You have new instructor approval updates:</div>
          {msgs}
        </div>
      );
      setIsAOReminderOpen(true);
    } catch (error) {
      console.error("Error fetching AO reminder:", error);
    }
  };

  const fetchInstructorAOPending = async () => {
    const instructorId = userContext?.user?.id;
    const semesterId = semesterContext?.selectedSemester?.value;
    const programId = universityContext?.selectedProgram?.id;
    if (!instructorId || !semesterId || !programId) return;
    try {
      const res = await axios.get(
        `/instructor/pending-approval?instructor_id=${instructorId}&semester_id=${semesterId}&program_id=${programId}`
      );
      const data: Array<any> = Array.isArray(res.data) ? res.data : [];
      if (data.length > 0) {
        setIsAOPendingOpen(true);
      }
    } catch (error) {
      console.error("Error fetching instructor AO pending:", error);
    }
  };

  const snacks = [
    isWarningOpen && {
      key: "warning",
      header: "",
      message: warningMessage,
      type: "warning",
      autoHideDuration: 7000,
      setOpen: setIsWarningOpen,
    },

    userContext.isSignedIn && isRemindOpen && {
      key: "announcement",
      header: "New Announcement!",
      message: "There is a new announcement.",
      type: "announcement",
      autoHideDuration: 7000,
      setOpen: setIsRemindOpen,
    },

    isSnackbarOpen && {
      key: "success",
      header: "",
      message,
      type: "success",
      setOpen: setIsSnackbarOpen,
    },

    isAOPendingOpen && {
      key: "ao-pending",
      header: "AO Approval Requests",
      message: location.pathname.includes("instructor-competencies")
        ? "Some students are requesting approval to join Assessment-Only (AO) competencies. Please review the requests and update each request's status."
        : "Some students are requesting to join AO competencies. Please go to My Competencies to review.",
      type: "info",
      autoHideDuration: 10000,
      setOpen: setIsAOPendingOpen,
    },

    isAOReminderOpen && {
      key: "ao-reminder",
      header: "AO Competency Update",
      message: aoReminderMessage,
      type: "warning",
      autoHideDuration: 15000,
      setOpen: setIsAOReminderOpen,
    },

  ].filter(Boolean);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <BasicLayout>
          <Routes>
            {!isLoading && (
              <>
                {/* <Route
                  index
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      {userContext.user.role === 'student' && (
                        <Navigate to={'roadmap'} replace />
                      )}
                      {userContext.user.role === 'instuctor' && (
                        <Navigate to={'explore'} replace />
                      )}
                    </ProtectedRoute>
                  }
                /> */}

                <Route
                  path="roadmap"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <RoadMapPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="roadmap/detail"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <RoadMapDetailPage
                        isSnackbarOpen={isSnackbarOpen}
                        message={message}
                        setIsSnackbarOpen={setIsSnackbarOpen}
                        setMessage={setMessage}
                      />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="competency/detail"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <CompetencyDetail />
                    </ProtectedRoute>
                  }
                /> */}
                <Route
                  path="help"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <HelpPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="roadmap/timeline"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <RoadMapTimelinePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="recommended"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <RecommendedRoadMapPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="announcement"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <AnnouncementPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="explore/*"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <QuestsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="calendar"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <ActivityCalendarPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="mycompetencies"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      {/* <RoadMapDetailPage /> */}
                      <MyCards />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="instructor-competencies"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <InstructorQuestsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="credits"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <StudentCreditsPage globalSnackCount={snacks.length} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="portfolio"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <Portfolio />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="student-roadmaps"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <StudentTimelinesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="student-cards"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <InstructorStudentCard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="student-credits"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <InstructorStudentCreditsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="profile"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <MasteryLevelPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="student-profile"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <InstructorView />
                    </ProtectedRoute>
                  }
                />
                <Route path="/signout" element={<SignOutPage />} />
                <Route path="/unauthorized" element={<UnauthorizedPage />} />
                <Route path="/oauth/login" />
                <Route
                  path="/signin"
                  element={
                    <UnprotectedRoute isSignedIn={userContext.isSignedIn}>
                      <SignInPage />
                    </UnprotectedRoute>
                  }
                />
                {userContext.user.role === 1 ? (
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                        <Navigate replace to="/roadmap/timeline" />
                      </ProtectedRoute>
                    }
                  />
                ) : (
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                        <Navigate replace to="/explore" />
                      </ProtectedRoute>
                    }
                  />
                )}
                <Route
                  path="*"
                  element={
                    <ProtectedRoute isSignedIn={userContext.isSignedIn}>
                      <NotFoundPage />
                    </ProtectedRoute>
                  }
                />
              </>
            )}
          </Routes>
          {/* {userContext.isSignedIn && (
            <SnackBar
              isOpen={true}
              setOpen={setIsRemindOpen}
              header="New Announcement!"
              message="There is a new announcement."
              type="announcement"
              style={{ bottom: "104px" }}
            />
          )}
          <SnackBar
            isOpen={isSnackbarOpen}
            setOpen={setIsSnackbarOpen}
            header=""
            message={message}
            type="success"
            style={{ bottom: "24px" }}
          />
          <SnackBar
            isOpen={true}
            setOpen={setIsWarningOpen}
            header=""
            message={warningMessage}
            type="warning"
            autoHideDuration={8000}
            style={{ bottom: "184px" }}
          /> */}
          {snacks.map((snack: any, index) => (
            <SnackBar
              key={snack.key}
              isOpen={true}
              setOpen={snack.setOpen}
              header={snack.header}
              message={snack.message}
              type={snack.type}
              autoHideDuration={snack.autoHideDuration}
              style={{
                bottom: `${30 + index * 120}px`,
              }}
            />
          ))}
        </BasicLayout>
      </ThemeProvider>
    </div>
  );
}

export default App;
